import { CommonActions, MessageExchange } from 'ap-message-exchange';

import { trackUiAppId } from '../config/track-config';
import { Notification, NotificationStatus, NotificationType } from '../models/Notification';
import { OverrideMessage } from './article-overrides.utils';

export const messageExchange = new MessageExchange(trackUiAppId);

export const messageExchangeConfig = {
  deliveryChoices: 'DELIVERY_CHOICE_FLOW',
  atlSetPreference: 'ATL_SET_PREFERENCE',
  articleAdd: 'articleAdd',
  overrideArticle: 'overrideArticle',
  redirectFromLogin: 'REDIRECT_FROM_ULP',
  queryTrackingId: 'queryTrackingId',
};

type MessagePayloadType = {
  [key: string]: string;
};

export const postMxMessage = (action: string, payload: MessagePayloadType, recipient?: string, lifeSpan?: number) => {
  const message = messageExchange.create(action, payload);
  if (recipient) message.recipient = recipient;
  if (lifeSpan) message.lifeSpan = lifeSpan;
  messageExchange.post(message);
};

export const postMxNotificationMsg = (payload: MessagePayloadType, recipient?: string) => {
  postMxMessage(CommonActions.NOTIFICATION, payload, recipient);
};

export const readMxMessage = (action?: string, preserve = false) => {
  return messageExchange.read(action, preserve);
};

export const readMxNotificationMsg = (preserve = false): Notification[] => {
  const mxMsgs = readMxMessage(CommonActions.NOTIFICATION, preserve);
  const notifications: Notification[] = [];

  if (mxMsgs && mxMsgs.length > 0) {
    mxMsgs.forEach((mxMsg) => {
      const payload = mxMsg.payload;

      if (!payload?.message) return;

      const notification: Notification = {
        type: payload.type || NotificationType.ALERT,
        status: NotificationStatus.ERROR,
        message: payload.message,
      };

      if (payload.status) {
        notification.status = payload.status;
      } else if (payload.isError) {
        notification.status = NotificationStatus.ERROR;
      } else if (payload.isWarning) {
        notification.status = NotificationStatus.WARNING;
      } else {
        notification.status = NotificationStatus.SUCCESS;
      }

      notifications.push(notification);
    });
  }
  return notifications;
};

export const readArticleOverrideMsg = (): Array<OverrideMessage> => {
  return readMxMessage(messageExchangeConfig.overrideArticle);
};

export const hasMxMessage = (action: string, preserve = false) => {
  const messages = messageExchange.read(action, preserve);
  return messages.length > 0;
};

export const clearMxMessage = (guid?: string) => {
  if (!guid) return messageExchange.read();

  const tempMx = new MessageExchange(guid);
  return tempMx.read();
};
